import { render, staticRenderFns } from "./ClickToCall.vue?vue&type=template&id=15d4c59c&scoped=true&"
import script from "./ClickToCall.vue?vue&type=script&lang=js&"
export * from "./ClickToCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d4c59c",
  null
  
)

export default component.exports